// extracted by mini-css-extract-plugin
export default {"imgHolder":"StoriesTable_imgHolder__CpkDc","storyImg":"StoriesTable_storyImg__zh-Wi","inputFile":"StoriesTable_inputFile__prFD4","imgg":"StoriesTable_imgg__1HHzV"};